import { executeRequest, HTTP_METHODS } from "@/common/utils/http/httpClient";

export async function getDocuments() {
  return await executeRequest(
    {
      url: `/assets/mocks/documents.json`,
      method: HTTP_METHODS.GET
    },
    false
  );
}
